// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gallery-title{
    font-size: 2em;
    font-weight: 300;
}

.gallery-description{
    font-size: .9em;
    font-weight: 100;
    max-width: 45em;
}

.gallery-categories{
    margin: 0;
    padding: 0;
    width: 100%;
    display: flex;
    gap: 1em;
}

.gallery-gallery, .related-gallery{
    width: 100%;
    list-style: none;
    display: flex;
    gap: 32px;
    flex-wrap: wrap;
}


.gallery-item {
    overflow: hidden;
    width: calc(50% - 16px);
    cursor: pointer;
}

.gallery-item-related {
    width: 20em;
}

.gallery-item:hover {
    transform: scale(1.02);
    transition: transform .3s;
}

.gallery-item-image{
    width: 100%;
    height: 20em;
    position: relative;
    overflow: hidden;
    margin-bottom: 1em;
}

.gallery-item-image-extended {
    height: 30em;
}

.gallery-item-image > img{
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.gallery-item-category{
    font-size: .8em;
    position: absolute;
    top: 1em;
    left: 1em;
}

.gallery-item-description{
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 0;
    margin: 0;
}

.gallery-item-description-title{
    font-size: 1em;
    font-weight: 100;
    padding: 0;
    margin: 0;
}

.gallery-item-description-data{
    display: flex;
    gap: 1em;
    font-size: .8em;
    font-weight: 100;
    align-items: center;
    color: rgba(255, 255, 255, .7);
    padding: 0;
    margin: 0;
}

.gallery-chip, .gallery-categories {
    text-transform: capitalize;
}

.related-content {
    width: 100%;
    margin-top: 2em;
}
.related-gallery {
    gap: 3em;
    padding: 0;
    margin: 0;
}

.related-content-title {
    font-size: 1em;
    font-weight: 300;
    margin-bottom: 1em;
    text-transform: uppercase;
}

.related-content-carrousel {
    width: 100%;
}

.related-projects-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.related-projects-discover-text {
    font-weight: 100;
    text-transform: uppercase;
    color: rgba(255, 255, 255, .6);
    display: flex;
    align-items: center;
    gap: .5em;
}

@media screen and (max-width: 768px) {
    .gallery-description{
        text-align: center;
    }
    
    .gallery-categories{
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
        gap: 0;
    }
    
    .gallery-gallery{
        flex-wrap: nowrap;
        flex-direction: column;
    }
    
    .gallery-item {
        width: 100%;
    }
    
    .gallery-item-image{
        height: 10em;
    }
    

    .gallery-item-image-extended {
        height: 20em;
    }
    
    .gallery-item-description-title{
        font-size: .9em;
    }
    
    .gallery-item-description-data{
        display: flex;
        gap: 1em;
        font-size: .8em;
        font-weight: 100;
        align-items: center;
        color: rgba(255, 255, 255, .7);
        padding: 0;
        margin: 0;
    }

    .related-project-title {
        font-size: .8em;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/gallery.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,UAAU;IACV,WAAW;IACX,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,SAAS;IACT,eAAe;AACnB;;;AAGA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,8BAA8B;IAC9B,UAAU;IACV,SAAS;AACb;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;AACA;IACI,QAAQ;IACR,UAAU;IACV,SAAS;AACb;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;QACnB,uBAAuB;QACvB,eAAe;QACf,MAAM;IACV;;IAEA;QACI,iBAAiB;QACjB,sBAAsB;IAC1B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,YAAY;IAChB;;;IAGA;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,QAAQ;QACR,eAAe;QACf,gBAAgB;QAChB,mBAAmB;QACnB,8BAA8B;QAC9B,UAAU;QACV,SAAS;IACb;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".gallery-title{\n    font-size: 2em;\n    font-weight: 300;\n}\n\n.gallery-description{\n    font-size: .9em;\n    font-weight: 100;\n    max-width: 45em;\n}\n\n.gallery-categories{\n    margin: 0;\n    padding: 0;\n    width: 100%;\n    display: flex;\n    gap: 1em;\n}\n\n.gallery-gallery, .related-gallery{\n    width: 100%;\n    list-style: none;\n    display: flex;\n    gap: 32px;\n    flex-wrap: wrap;\n}\n\n\n.gallery-item {\n    overflow: hidden;\n    width: calc(50% - 16px);\n    cursor: pointer;\n}\n\n.gallery-item-related {\n    width: 20em;\n}\n\n.gallery-item:hover {\n    transform: scale(1.02);\n    transition: transform .3s;\n}\n\n.gallery-item-image{\n    width: 100%;\n    height: 20em;\n    position: relative;\n    overflow: hidden;\n    margin-bottom: 1em;\n}\n\n.gallery-item-image-extended {\n    height: 30em;\n}\n\n.gallery-item-image > img{\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.gallery-item-category{\n    font-size: .8em;\n    position: absolute;\n    top: 1em;\n    left: 1em;\n}\n\n.gallery-item-description{\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    padding: 0;\n    margin: 0;\n}\n\n.gallery-item-description-title{\n    font-size: 1em;\n    font-weight: 100;\n    padding: 0;\n    margin: 0;\n}\n\n.gallery-item-description-data{\n    display: flex;\n    gap: 1em;\n    font-size: .8em;\n    font-weight: 100;\n    align-items: center;\n    color: rgba(255, 255, 255, .7);\n    padding: 0;\n    margin: 0;\n}\n\n.gallery-chip, .gallery-categories {\n    text-transform: capitalize;\n}\n\n.related-content {\n    width: 100%;\n    margin-top: 2em;\n}\n.related-gallery {\n    gap: 3em;\n    padding: 0;\n    margin: 0;\n}\n\n.related-content-title {\n    font-size: 1em;\n    font-weight: 300;\n    margin-bottom: 1em;\n    text-transform: uppercase;\n}\n\n.related-content-carrousel {\n    width: 100%;\n}\n\n.related-projects-title {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n.related-projects-discover-text {\n    font-weight: 100;\n    text-transform: uppercase;\n    color: rgba(255, 255, 255, .6);\n    display: flex;\n    align-items: center;\n    gap: .5em;\n}\n\n@media screen and (max-width: 768px) {\n    .gallery-description{\n        text-align: center;\n    }\n    \n    .gallery-categories{\n        align-items: center;\n        justify-content: center;\n        flex-wrap: wrap;\n        gap: 0;\n    }\n    \n    .gallery-gallery{\n        flex-wrap: nowrap;\n        flex-direction: column;\n    }\n    \n    .gallery-item {\n        width: 100%;\n    }\n    \n    .gallery-item-image{\n        height: 10em;\n    }\n    \n\n    .gallery-item-image-extended {\n        height: 20em;\n    }\n    \n    .gallery-item-description-title{\n        font-size: .9em;\n    }\n    \n    .gallery-item-description-data{\n        display: flex;\n        gap: 1em;\n        font-size: .8em;\n        font-weight: 100;\n        align-items: center;\n        color: rgba(255, 255, 255, .7);\n        padding: 0;\n        margin: 0;\n    }\n\n    .related-project-title {\n        font-size: .8em;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
